import { UpdatePackageInstallationsCount } from "@/model/data/updates/UpdatePackageInstallationsCount";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetUpdatePackagesResData extends ServiceResponseData {
    updatePackagesList: UpdatePackageInstallationsCount[];

    constructor(response: AxiosResponse) {
        super(response);
        this.updatePackagesList = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.UpdatePackages && obj.UpdatePackages.length > 0) {
            obj.UpdatePackages.forEach((e) => {
                let updatePackage = new UpdatePackageInstallationsCount();
                updatePackage.parse(e);
                this.updatePackagesList.push(updatePackage);
            });
        }
    }
}
